import {
  UpsertUserOnboardingSchema,
  UserOnboardingSchema,
} from "@redotech/redo-onboarding-common/user-onboarding";
import * as zExt from "@redotech/rpc/ext";

export const upsertUserOnboarding = {
  name: "upsertUserOnboarding" as const,
  input: zExt.filterToValid(UpsertUserOnboardingSchema.omit({ userId: true })),
  output: UserOnboardingSchema.optional(),
};
